/**
 * Role definitions - modules and permissions per role.
 * Firestore (userManagement) is the source of truth for who has which role.
 */

export const ROLES = {
  ADMIN: 'admin',
  CONSULTANT: 'consultant',
  SUPPORT: 'support',
};

/** Sidebar modules - which nav items each role can see (order matches sidebar) */
export const MODULES_BY_ROLE = {
  [ROLES.ADMIN]: ['dashboard', 'quiz', 'reports', 'calendar', 'timesheets', 'users', 'profile'],
  // Original consultant modules (restore by replacing the line below):
  // [ROLES.CONSULTANT]: ['dashboard', 'quiz', 'calendar', 'profile'],
  [ROLES.CONSULTANT]: ['quiz', 'profile'],
  [ROLES.SUPPORT]: ['timesheets', 'profile'],
};

/**
 * Temporarily hide these Consultants Portal sections without deleting them.
 * Clear this list AND restore MODULES_BY_ROLE.consultant to re-enable Dashboard and Calendar.
 */
export const HIDDEN_CONSULTANT_MODULES = ['dashboard', 'calendar'];

/** Path to section mapping */
export const PATH_TO_SECTION = {
  '/dashboard': 'dashboard',
  '/quiz': 'quiz',
  '/users': 'users',
  '/reports': 'reports',
  '/profile': 'profile',
  '/calendar': 'calendar',
  '/timesheets': 'timesheets',
};

/** Section to path mapping */
export const SECTION_TO_PATH = {
  dashboard: '/dashboard',
  quiz: '/quiz',
  users: '/users',
  reports: '/reports',
  profile: '/profile',
  calendar: '/calendar',
  timesheets: '/timesheets',
};

/** Permissions - what each role can do */
export const PERMISSIONS_BY_ROLE = {
  [ROLES.ADMIN]: {
    canUpload: true,
    canCreateSession: true,
    canAssignUsers: true,
    canManageUsers: true,
    canViewDashboard: true,
    canTakeQuiz: true,
  },
  [ROLES.CONSULTANT]: {
    canUpload: true,
    canCreateSession: true,
    canAssignUsers: true,
    canManageUsers: false,
    canViewDashboard: true,
    canTakeQuiz: true,
  },
  [ROLES.SUPPORT]: {
    canUpload: false,
    canCreateSession: false,
    canAssignUsers: false,
    canManageUsers: false,
    canViewDashboard: false,
    canTakeQuiz: false,
  },
};

/** Human-readable labels */
export const ROLE_LABELS = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.CONSULTANT]: 'Consultant',
  [ROLES.SUPPORT]: 'Support',
};

export const getModulesForRole = (role) => {
  const modules = MODULES_BY_ROLE[role] || [];
  if (role === ROLES.CONSULTANT) {
    return modules.filter((id) => !HIDDEN_CONSULTANT_MODULES.includes(id));
  }
  return modules;
};
export const getPermissionsForRole = (role) => PERMISSIONS_BY_ROLE[role] || {};
export const getRoleLabel = (role) => ROLE_LABELS[role] || role;
